<template>
  <div class="checkbox">
    <el-checkbox-group
      v-model="checkList"
      @change="change"
    >
      <el-checkbox
        v-for="option in question.optionList"
        :key="option"
        :label="option"
      ></el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "checkbox",
  mixins: [mixins],
  data() {
    return {
      checkList: [],
    };
  },
  methods: {
    change(value) {
      this.answerChange(value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>